export default __webpack_public_path__ + "static/media/adidas-ads.5f0e11ee.png";